import { createSlice } from '@reduxjs/toolkit';

export interface TenantSummary {
  clientCount: number;
  internalGroupCount: number;
  legalEntityCount: number;
  lastUpdated: any;
  userCount: number;
}
export interface TenantSummaryData {
  data: TenantSummary;
  loading: boolean;
}

const initialState: TenantSummaryData = {
  data: {} as TenantSummary,
  loading: false,
};

const tenantSummary = createSlice({
  name: 'Tenant Summary',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    updateTenantSummary: (state, action) => {
      state.data = action.payload?.data?.summaryStats || {};
    },
  },
});

export const { startLoading, stopLoading, updateTenantSummary } = tenantSummary.actions;
export default tenantSummary.reducer;
